import { CharKeys } from "../../state";

// For text sizes are group 0-1:S, 2-3:M, 4-5:L, none:X

export default {
  // fucker organ
  [CharKeys.prowessTypes.tongue]: {
    sizeOpt: false,
    sizeX: {
      [CharKeys.resistTypes.touch]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### wet tongue over xxxx's face`,
          `++++ licks xxxx's soft thighs, nipping #### gently`,
        ],
      },
      [CharKeys.resistTypes.breasts]: {
        sizeOpt: 3,
        sizeS: [
          `++++ licks xxxx's little tits, passionately nipping ==== breast meat`,
          `++++ playfully gropes xxxx's tits and proceeds to slather ==== nipples with saliva`,
        ],
        sizeM: [
          `++++ licks energetically between xxxx's tits, spitting on ==== chest for extra wetness`,
          `++++ spits over xxxx's lovely nipples, then sucks it off tenderly`,
        ],
        sizeL: [
          `++++'s face is buried as she tenderly motorboats #### face, before kissing ==== big breasts`,
          `++++ nips xxxx's solid nipples, before tendlerly licking them with #### wet tongue`,
        ],
      },
      [CharKeys.resistTypes.mouth]: {
        sizeOpt: false,
        sizeX: [
          `++++ slips #### tongue into xxxx's mouth, and kisses ==== deeply`,
          `++++ slides #### wet tongue over xxxx's tongue, french kissing ==== passionately`,
          `++++ dribbles #### saliva into xxxx's mouth`,
          `++++ runs #### explorative tongue eagerly around xxxx's mouth`,
          `++++ slips #### tongue into xxxx's mouth`,
        ],
      },
      [CharKeys.resistTypes.cock]: {
        sizeOpt: 3,
        sizeS: [
          `++++ evelopes xxxx's small cock with #### mouth, sucking ==== hungrily `,
          `++++ licks xxxx's cute cock with #### tongue, running it around ==== glans`,
        ],
        sizeM: [
          `++++ rubs #### tongue softly against xxxx's beefy cock`,
          `++++ licks xxxx's big cock with #### tongue, before sliding it into #### mouth`,
        ],
        sizeL: [
          `++++ hungrily swallows the massive member, while pumping it's base tenderly`,
          `++++ rubs xxxx's cock, pumping it steadily, and kissing the glans with #### tongue`,
        ],
      },
      [CharKeys.resistTypes.vagina]: {
        sizeOpt: false,
        sizeX: [
          `++++ sucks xxxx's clit with #### mouth`,
          `++++ rubs xxxx's pussy with the tip of #### tongue`,
          `++++ pushes #### tongue deep into xxxx's pussy, exploring it's depths`,
        ],
      },
      [CharKeys.resistTypes.anus]: {
        sizeOpt: false,
        sizeX: [
          `++++ explores xxxx's backdoor tenderly with #### tongue`,
          `++++ slather xxxx's arse with spit and saliva, teasing the edge with #### tongue`,
        ],
      },
    },
  },
  [CharKeys.prowessTypes.touch]: {
    sizeOpt: false,
    sizeX: {
      [CharKeys.resistTypes.touch]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### hands over xxxx's neck, slowly tightening #### grip`,
          `++++ rubs against xxxx's body tenderly, pushing ==== into the floor`,
        ],
      },
      [CharKeys.resistTypes.breasts]: {
        sizeOpt: 3,
        sizeS: [
          `++++ squeezes xxxx's little tits, tenderly kneading ==== small breast meat`,
          `++++ playfully gropes xxxx's tits, and pinches ==== nipples`,
        ],
        sizeM: [
          `++++ tenderly gropes xxxx's tits, and squeezes ==== nipples`,
          `++++ spits on === hands before kneading xxxx's breasts tenderly and teasing ==== lovely nipples`,
        ],
        sizeL: [
          `++++ gropes xxxx's big breasts, and kneading them hungrily`,
          `++++ tugs gently on xxxx's hard nipples, before softly playing with ==== breasts`,
        ],
      },
      [CharKeys.resistTypes.mouth]: {
        sizeOpt: false,
        sizeX: [
          `++++ tugs tenderly on ==== lips, teasing ==== mouth softly`,
          `++++ stokes ==== face, whispering dirty words into her ear`,
        ],
      },
      [CharKeys.resistTypes.cock]: {
        sizeOpt: 3,
        sizeS: [
          `++++ evelopes xxxx's small cock with #### hands, massaging tenderly`,
          `++++ strokes xxxx's cute cock with #### hand, then rubs ==== glans`,
        ],
        sizeM: [
          `++++ tenderly pumps xxxx's beefy cock`,
          `++++ strokes xxxx's big cock, before massaging ==== balls`,
        ],
        sizeL: [
          `++++ gets a solid two-handed grip, before pumping ==== massive cock tenderly`,
          `++++ teases xxxx's cock, before massaging it pleasurably`,
        ],
      },
      [CharKeys.resistTypes.vagina]: {
        sizeOpt: false,
        sizeX: [
          `++++ sucks xxxx's clit with #### mouth`,
          `++++ rubs xxxx's pussy with the tip of #### tongue`,
          `++++ pushes #### tongue deep into xxxx's pussy, exploring it's depths`,
        ],
      },
      [CharKeys.resistTypes.anus]: {
        sizeOpt: false,
        sizeX: [
          `++++ fucks xxxx's backdoor with #### tongue`,
          `++++ slather xxxx's arse with spit and saliva, teasing the edge with #### tongue`,
        ],
      },
    },
  },
  [CharKeys.prowessTypes.cock]: {
    sizeOpt: 3,
    // text varies by organ size, grouped into three
    sizeS: {
      [CharKeys.resistTypes.touch]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### small cock over xxxx's face`,
          `++++ dry humps xxxx's soft thighs`,
        ],
      },
      [CharKeys.resistTypes.breasts]: {
        sizeOpt: 3,
        sizeS: [
          `++++ rubs #### small cock tenderly between xxxx's little tits`,
          `++++ rubs #### cute cock playfully on xxxx's soft thighs`,
        ],
        sizeM: [
          `++++ slides #### little cock between, xxxx's tits, fucking them energetically`,
          `++++ runs #### precum covered glans over xxxx's lovely nipples`,
        ],
        sizeL: [
          `++++'s little cock is enveloped in xxxx's busty rack`,
          `++++ pushes #### cock hard against xxxx's solid nipples`,
        ],
      },
      [CharKeys.resistTypes.mouth]: {
        sizeOpt: 3,
        sizeS: [
          `++++ slides #### small cock into xxxx's little throat`,
          `++++ rubs #### cute cock on xxxx's tongue`,
        ],
        sizeM: [
          `++++ slides #### little cock between xxxx's lips`,
          `++++ places #### precum covered cock in xxxx's mouth`,
        ],
        sizeL: [
          `'s little cock is rubbed around xxxx's mouth`,
          `++++ slides #### cock into xxxx's mouth`,
        ],
      },
      [CharKeys.resistTypes.cock]: {
        sizeOpt: 3,
        sizeS: [
          `++++ rubs #### small cock against xxxx's`,
          `++++ brushes xxxx's cute cock with #### own`,
        ],
        sizeM: [
          `++++ rubs #### cock tenderly against xxxx's beefier cock`,
          `++++ rubs xxxx's bigger cock with #### own`,
        ],
        sizeL: [
          `'s little cock is rubbed around xxxx's`,
          `++++ pushes #### cock under xxxx's foreskin, rubbing it around`,
        ],
      },
      [CharKeys.resistTypes.vagina]: {
        sizeOpt: 3,
        sizeS: [
          `++++ fucks xxxx's clit with #### small cock`,
          `++++ fucks xxxx's pussy with #### cute cock`,
        ],
        sizeM: [
          `++++ rubs tenderly against xxxx's clit`,
          `++++ rubs xxxx's pussy lips with #### erect cock`,
        ],
        sizeL: [
          `'s little cock is rubbed around xxxx's pussy`,
          `++++ pushes #### cock into xxxx's pussy, rubbing it around`,
        ],
      },
      [CharKeys.resistTypes.anus]: {
        sizeOpt: 3,
        sizeS: [
          `++++ fucks xxxx's backdoor with #### small cock`,
          `++++ fucks xxxx's arse with #### cute cock`,
        ],
        sizeM: [
          `++++ rubs tenderly against xxxx's back door`,
          `++++ rubs xxxx's second cunt with #### cock`,
        ],
        sizeL: [
          `'s little cock is rubbed around xxxx's arse entrance`,
          `++++ pushes #### cock into xxxx's arse, praising ==== for ==== gaping hole`,
        ],
      },
    },
    sizeM: {
      [CharKeys.resistTypes.touch]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### hard cock over xxxx's face, letting her smell it's arousing musk`,
          `++++ rubs #### pre-cum dribbling dick over xxxx's chest`,
          `++++ fucks xxxx's soft thighs`,
        ],
      },
      [CharKeys.resistTypes.breasts]: {
        sizeOpt: 3,
        sizeS: [
          `++++ pounds #### fat cock tenderly between xxxx's tiny tits`,
          `++++ rubs #### hard cock playfully across xxxx's soft breasts`,
        ],
        sizeM: [
          `++++ slides #### ready cock between xxxx's tits, fucking them tenderly`,
          `++++ pushes #### precum covered glans into xxxx's lovely nipples`,
        ],
        sizeL: [
          `++++'s fat member is enveloped in xxxx's busty rack`,
          `++++ grabs xxxx's breasts and tenderly fucks ==== rack`,
        ],
      },
      [CharKeys.resistTypes.mouth]: {
        sizeOpt: 3,
        sizeS: [
          `++++ slides #### pulsing cock into xxxx's tight throat`,
          `++++ rubs #### dick on xxxx's tongue`,
          `++++ holds xxxx's head while slipping #### hard cock into ==== mouth`,
        ],
        sizeM: [
          `++++ slides #### fat cock between xxxx's lips`,
          `++++ holds #### precum covered cock in xxxx's mouth`,
          `++++ rubs #### dick on xxxx's big tongue`,
          `++++ holds xxxx's head while stuffing #### hard cock into ==== mouth`,
        ],
        sizeL: [
          `++++'s meaty cock is rubbed around xxxx's mouth`,
          `++++ slips #### huge cock into xxxx's mouth`,
          `++++ gently fucks xxxx face, letting ==== taste #### girthy member`,
        ],
      },
      [CharKeys.resistTypes.cock]: {
        sizeOpt: 3,
        sizeS: [
          `++++ crushed #### cock against xxxx's tiny one`,
          `++++ rubs xxxx's cute cock with #### own, fatter cock`,
        ],
        sizeM: [
          `++++ rubs tenderly against xxxx's cock`,
          `++++ rubs xxxx's cock with #### own`,
        ],
        sizeL: [
          `'s cock is rubbed around xxxx's`,
          `++++ pushes #### cock under xxxx's foreskin, rubbing it around`,
        ],
      },
      [CharKeys.resistTypes.vagina]: {
        sizeOpt: 3,
        sizeS: [
          `++++ fucks xxxx's clit with #### ready cock`,
          `++++ fucks xxxx's pussy with #### swollen cock`,
          `++++ pushes #### way gently into xxxx's tight cunt`,
          `++++ smoothly inserts #### fat cock between xxxx's tight pussy lips`,
        ],
        sizeM: [
          `++++ rubs xxxx's clit softly`,
          `++++ rubs xxxx's pussy lips with #### erect cock`,
          `++++ fucks xxxx's cunt gently`,
        ],
        sizeL: [
          `++++'s little cock is rubbed around xxxx's pussy`,
          `++++ pushes #### cock into xxxx's pussy, rubbing it around`,
          `++++ pushes #### way gently into xxxx's juicy cunt`,
        ],
      },
      [CharKeys.resistTypes.anus]: {
        sizeOpt: 3,
        sizeS: [
          `++++ tenderly fucks xxxx's backdoor`,
          `++++ fucks xxxx's arse with #### hungry cock`,
          `++++ pushes #### way gently into xxxx's tight arse`,
          `++++ grabs xxxx's arse cheeks and smoothly inserts #### fat cock into xxxx's tight back passage`,
        ],
        sizeM: [
          `++++ rubs ####self tenderly between xxxx's arsecheeks`,
          `++++ rubs xxxx's second cunt with #### cock`,
          `++++ pushes #### way gently into xxxx's warm arse`,
          `++++ grabs xxxx's arse cheeks and smoothly inserts #### fat cock into xxxx's fresh back passage`,
        ],
        sizeL: [
          `'s little cock is rubbed around xxxx's arse entrance`,
          `++++ pushes #### cock into xxxx's arse, praising ==== for ==== gaping hole`,
          `++++ pushes #### way gently into xxxx's loose arse`,
          `++++ grabs xxxx's arse cheeks and slips #### fat cock into xxxx's open back passage smoothly`,
        ],
      },
    },
    sizeL: {
      [CharKeys.resistTypes.touch]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### massive cock over xxxx's face, letting ==== inhale it's arousing, musty scent`,
          `++++ rubs #### pre-cum dribbling dick over xxxx's chest`,
          `++++ fucks xxxx's soft thighs`,
        ],
      },
      [CharKeys.resistTypes.breasts]: {
        sizeOpt: 3,
        sizeS: [
          `++++ pounds #### giant cock gently between xxxx's tiny tits`,
          `++++ rubs #### hard cock playfully accross xxxx's soft breasts`,
        ],
        sizeM: [
          `++++ slides #### massive cock between xxxx's tits, fucking them gently`,
          `++++ pushes #### precum covered glans into xxxx's lovely nipples`,
        ],
        sizeL: [
          `++++'s giant swollen member is enveloped in xxxx's busty rack`,
          `++++ grabs xxxx's breasts and gently fucks ==== rack, with #### giant meaty pole`,
        ],
      },
      [CharKeys.resistTypes.mouth]: {
        sizeOpt: 3,
        sizeS: [
          `++++ slips #### giant cock into xxxx's tight throat, softly massaging ==== throat`,
          `++++ rubs #### big dick on xxxx's tongue`,
          `++++ holds xxxx's head while stuffing #### giant cock into ==== tiny mouth`,
          `stroking xxxx's' hair, ++++ fucks ==== tight little mouth passionately`,
        ],
        sizeM: [
          `++++ slides #### enourmous cock between xxxx's lips`,
          `++++ holds #### enourmous, precum covered cock in xxxx's mouth`,
          `++++ rubs #### giant dick on xxxx's big tongue`,
        ],
        sizeL: [
          `++++'s enourmous cock is rubbed around xxxx's mouth`,
          `++++ pushes ==== enourmous cock into xxxx's mouth`,
          `++++ strokes xxxx's hair while stuffing #### hard cock into ==== mouth`,
        ],
      },
      [CharKeys.resistTypes.cock]: {
        sizeOpt: 3,
        sizeS: [
          `++++ crushed #### enourmous cock against xxxx's tiny one`,
          `++++ rubs xxxx's cute cock with #### own, enourmous cock`,
        ],
        sizeM: [
          `++++ rubs tenderly against xxxx's cock`,
          `++++ rubs xxxx's cock with #### own giant one`,
        ],
        sizeL: [
          `'s cock is rubbed around xxxx's`,
          `++++ pushes #### cock against xxxx's, rubbing it softly`,
        ],
      },
      [CharKeys.resistTypes.vagina]: {
        sizeOpt: 3,
        sizeS: [
          `++++ fucks xxxx's clit with #### enourmous, ready cock`,
          `++++ fucks xxxx's tight pussy with #### swollen cock`,
          `++++ pushes #### gaint meatstick passionately into xxxx's tight cunt`,
          `++++ smoothly inserts #### enourmous cock between xxxx's tight pussy lips`,
        ],
        sizeM: [
          `++++ rubs xxxx's clit softly`,
          `++++ rubs xxxx's pussy lips with #### enourmous, erect cock`,
          `++++ fucks xxxx's cunt passionately`,
        ],
        sizeL: [
          `++++'s enourmous cock is rubbed around xxxx's pussy`,
          `++++ pushes #### enourmous cock into xxxx's pussy, rubbing it around`,
          `++++ pushes #### way passionately into xxxx's juicy cunt`,
        ],
      },
      [CharKeys.resistTypes.anus]: {
        sizeOpt: 3,
        sizeS: [
          `++++ fucks xxxx's backdoor`,
          `++++ fucks xxxx's arse with #### hungry, giant cock`,
          `++++ pushes #### enourmous cock passionately into xxxx's tight arse`,
          `++++ grabs xxxx's arse cheeks and smoothly inserts #### enourmous cock into xxxx's tight back passage`,
        ],
        sizeM: [
          `++++ rubs ####self tenderly between xxxx's arsecheeks`,
          `++++ rubs xxxx's second cunt with #### giant cock`,
          `++++ pushes #### way passionately into xxxx's warm arse`,
          `++++ grabs xxxx's arse cheeks and smoothly inserts #### enourmous cock into xxxx's fresh back passage`,
        ],
        sizeL: [
          `++++'s enourmous cock is rubbed around xxxx's arse entrance`,
          `++++ pushes #### cock into xxxx's arse, praising ==== for ==== gaping hole`,
          `++++ pushes #### way passionately into xxxx's loose arse`,
          `++++ grabs xxxx's arse cheeks and pushes #### fat cock into xxxx's open back passage`,
        ],
      },
    },
  },
  [CharKeys.prowessTypes.vagina]: {
    sizeOpt: 3,
    sizeS: {
      [CharKeys.resistTypes.touch]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### slippery pussy lips over xxxx's thigh`,
          `++++ rubs #### sticky lady cavern over xxxx's arms`,
          `++++ runs #### beautiful pussy over xxxx's soft torso`,
        ],
      },
      [CharKeys.resistTypes.breasts]: {
        sizeOpt: 3,
        sizeS: [
          `++++ rubs #### pussy lips over xxxx's tiny tits`,
          `++++ envelopes xxxx's nipples with #### pussy flaps`,
        ],
        sizeM: [
          `++++ rubs #### pussy lips over xxxx's full tits`,
          `++++ envelopes xxxx's nipples with #### pussy flaps`,
        ],
        sizeL: [
          `++++ rubs #### pussy lips over xxxx's heavy tits`,
          `++++ envelopes xxxx's nipples with #### pussy flaps`,
        ],
      },
      [CharKeys.resistTypes.mouth]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### slippery pussy lips over xxxx's mouth`,
          `++++ rubs #### sticky lady cavern over xxxx's face`,
          `++++ slides #### beautiful pussy over xxxx's soft tongue`,
        ],
      },
      [CharKeys.resistTypes.cock]: {
        sizeOpt: 3,
        sizeS: [
          `++++ rides xxxx's tiny cock`,
          `++++ presses #### cunt against xxxx's cute, hard shaft`,
          `++++ slowly slides xxxx's tiny cock into #### slippery, tight pussy`,
        ],
        sizeM: [
          `++++ rides xxxx's hard cock`,
          `++++ presses #### cunt against xxxx's hard shaft, rubbing herself along it`,
          `++++ slowly slides xxxx's hard cock into #### slippery, tight pussy`,
        ],
        sizeL: [
          `++++ rides the tip xxxx's enormous cock`,
          `++++ presses #### cunt against xxxx's long, hard shaft, rubbing herself along it's sizable length`,
          `++++ slowly pushes the glans of xxxx's giant cock into #### slippery, tight pussy`,
        ],
      },
      [CharKeys.resistTypes.vagina]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### slippery pussy lips over xxxx's`,
          `++++ grinds against xxxx's sopping wet pussy`,
          `++++ passionately brushes #### clit against xxxx's`,
        ],
      },
      [CharKeys.resistTypes.anus]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### slippery pussy lips over xxxx's soft buttcheeks`,
        ],
      },
    },
    sizeM: {
      [CharKeys.resistTypes.touch]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### slippery pussy lips over xxxx's thigh`,
          `++++ rubs #### sticky lady cavern over xxxx's arms`,
          `++++ pushes #### beautiful pussy over xxxx's soft torso`,
        ],
      },
      [CharKeys.resistTypes.breasts]: {
        sizeOpt: 3,
        sizeS: [
          `++++ rubs #### pussy lips over xxxx's tiny tits`,
          `++++ envelopes xxxx's nipples with #### pussy flaps`,
        ],
        sizeM: [
          `++++ rubs #### pussy lips over xxxx's full tits`,
          `++++ envelopes xxxx's nipples with #### pussy flaps`,
        ],
        sizeL: [
          `++++ rubs #### pussy lips over xxxx's heavy tits`,
          `++++ envelopes xxxx's nipples with #### pussy flaps`,
        ],
      },
      [CharKeys.resistTypes.mouth]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### slippery pussy lips over xxxx's mouth`,
          `++++ rubs #### sticky lady cavern over xxxx's face`,
          `++++ opens #### beautiful pussy over xxxx's soft tongue`,
        ],
      },
      [CharKeys.resistTypes.cock]: {
        sizeOpt: 3,
        sizeS: [
          `++++ rides xxxx's tiny cock`,
          `++++ presses #### cunt against xxxx's cute, hard shaft`,
          `++++ slowly slides xxxx's tiny cock into #### slippery, wet pussy`,
        ],
        sizeM: [
          `++++ rides xxxx's hard cock`,
          `++++ presses #### cunt against xxxx's hard shaft, rubbing herself along it`,
          `++++ slowly slides xxxx's hard cock into #### slippery, enveloping pussy`,
        ],
        sizeL: [
          `++++ rides the top xxxx's enormous cock`,
          `++++ presses #### cunt against xxxx's long, hard shaft, rubbing herself along it's sizable length`,
          `++++ slowly pushes the top of xxxx's giant cock into #### slippery wet pussy`,
        ],
      },
      [CharKeys.resistTypes.vagina]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### slippery pussy lips over xxxx's`,
          `++++ grinds against xxxx's sopping wet pussy`,
          `++++ passionately brushes #### clit against xxxx's`,
        ],
      },
      [CharKeys.resistTypes.anus]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### slippery pussy lips over xxxx's soft buttcheeks`,
        ],
      },
    },
    sizeL: {
      [CharKeys.resistTypes.touch]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### slippery pussy lips over xxxx's thigh`,
          `++++ rubs #### sticky lady cavern over xxxx's arms`,
          `++++ pushes #### beautiful pussy over xxxx's soft torso`,
        ],
      },
      [CharKeys.resistTypes.breasts]: {
        sizeOpt: 3,
        sizeS: [
          `++++ rubs #### pussy lips over xxxx's tiny tits`,
          `++++ envelopes xxxx's nipples with #### pussy flaps`,
        ],
        sizeM: [
          `++++ rubs #### pussy lips over xxxx's full tits`,
          `++++ envelopes xxxx's nipples with #### pussy flaps`,
        ],
        sizeL: [
          `++++ rubs #### pussy lips over xxxx's heavy tits`,
          `++++ envelopes xxxx's nipples with #### pussy flaps`,
        ],
      },
      [CharKeys.resistTypes.mouth]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### slippery pussy lips over xxxx's mouth`,
          `++++ rubs #### sticky lady cavern over xxxx's face`,
          `++++ pushes #### beautiful pussy over xxxx's soft tongue`,
        ],
      },
      [CharKeys.resistTypes.cock]: {
        sizeOpt: 3,
        sizeS: [
          `++++ rides xxxx's tiny cock`,
          `++++ presses #### cunt against xxxx's cute, hard shaft`,
          `++++ easily slides xxxx's tiny cock into #### slippery, warm pussy`,
        ],
        sizeM: [
          `++++ rides xxxx's hard cock`,
          `++++ presses #### cunt against xxxx's hard shaft, rubbing herself along it`,
          `++++ easily slides xxxx's hard cock into #### slippery, tight pussy`,
        ],
        sizeL: [
          `++++ rides xxxx's enormous cock`,
          `++++ presses #### cunt against xxxx's long, hard shaft, rubbing herself along it's sizable length`,
          `++++ slides ####self over xxxx's giant cock, taking the giant shaft entirely into #### pussy`,
        ],
      },
      [CharKeys.resistTypes.vagina]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### slippery pussy lips over xxxx's`,
          `++++ grinds against xxxx's sopping wet pussy`,
          `++++ passionately brushes #### clit against xxxx's`,
        ],
      },
      [CharKeys.resistTypes.anus]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### slippery pussy lips over xxxx's soft buttcheeks`,
        ],
      },
    },
  },
  [CharKeys.prowessTypes.anus]: {
    sizeOpt: 3,
    sizeS: {
      [CharKeys.resistTypes.mouth]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### arsecheeks over xxxx's mouth`,
          `++++ rubs #### arsecheeks over xxxx's face`,
          `++++ pushes #### beautiful backdoor over xxxx's soft tongue`,
        ],
      },
      [CharKeys.resistTypes.cock]: {
        sizeOpt: 3,
        sizeS: [
          `++++ rides xxxx's tiny cock, with #### tight anal passage`,
          `++++ presses #### arsecheeks against xxxx's cute, hard shaft`,
          `++++ slowly slides xxxx's tiny cock into #### slippery, tight arse`,
        ],
        sizeM: [
          `++++ rides the top of xxxx's hard cock, with #### tight anal passage`,
          `++++ presses #### arsecheeks against xxxx's hard shaft, rubbing #### cheeks along it`,
          `++++ slowly slides xxxx's hard cock into #### slippery, tight arse`,
        ],
        sizeL: [
          `++++ rides the tip xxxx's enormous cock, with #### tight anal passage`,
          `++++ presses #### arsecheeks against xxxx's long, hard shaft, rubbing ####self along it's sizable length`,
          `++++ slowly pushes the glans of xxxx's giant cock into #### slippery, tight arsehole`,
        ],
      },
      [CharKeys.resistTypes.touch]: {
        sizeOpt: false,
        sizeX: [`++++ rubs #### soft arsecheeks over xxxx's body`,],
      },
      [CharKeys.resistTypes.breasts]: {
        sizeOpt: false,
        sizeX: [`++++ rubs #### soft arsecheeks over xxxx's breasts`,],
      },
      [CharKeys.resistTypes.vagina]: {
        sizeOpt: false,
        sizeX: [`++++ rubs #### soft arsecheeks against xxxx's clit`,],
      },
      [CharKeys.resistTypes.anus]: {
        sizeOpt: false,
        sizeX: [`++++ rubs #### soft arsecheeks against xxxx's`,],
      },
    },
    sizeM: {
      [CharKeys.resistTypes.mouth]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### arsecheeks over xxxx's mouth`,
          `++++ rubs #### arsecheeks over xxxx's face`,
          `++++ pushes #### beautiful backdoor over xxxx's soft tongue`,
        ],
      },
      [CharKeys.resistTypes.cock]: {
        sizeOpt: 3,
        sizeS: [
          `++++ rides xxxx's tiny cock, with #### hungry anal passage`,
          `++++ presses #### arsecheeks against xxxx's cute, hard shaft`,
          `++++ easily slides xxxx's tiny cock into #### slippery, hungry arse`,
        ],
        sizeM: [
          `++++ rides the top of xxxx's hard cock, with #### hungry anal passage`,
          `++++ presses #### arsecheeks against xxxx's hard shaft, rubbing #### cheeks along it`,
          `++++ snugly slides xxxx's hard cock into #### slippery, hungry arse`,
        ],
        sizeL: [
          `++++ rides the tip xxxx's enormous cock, with #### tight anal passage`,
          `++++ presses #### arsecheeks against xxxx's long, hard shaft, rubbing ####self along it's sizable length`,
          `++++ slowly pushes the top of xxxx's giant cock into #### slippery, tight arsehole`,
        ],
      },

      [CharKeys.resistTypes.touch]: {
        sizeOpt: false,
        sizeX: [`++++ rubs #### soft arsecheeks over xxxx's body`,],
      },
      [CharKeys.resistTypes.breasts]: {
        sizeOpt: false,
        sizeX: [`++++ rubs #### soft arsecheeks over xxxx's breasts`,],
      },
      [CharKeys.resistTypes.vagina]: {
        sizeOpt: false,
        sizeX: [`++++ rubs #### soft arsecheeks against xxxx's clit`,],
      },
      [CharKeys.resistTypes.anus]: {
        sizeOpt: false,
        sizeX: [`++++ rubs #### soft arsecheeks against xxxx's`,],
      },
    },
    sizeL: {
      [CharKeys.resistTypes.mouth]: {
        sizeOpt: false,
        sizeX: [
          `++++ rubs #### arsecheeks over xxxx's mouth`,
          `++++ rubs #### arsecheeks over xxxx's face`,
          `++++ pushes #### beautiful backdoor over xxxx's soft tongue`,
        ],
      },
      [CharKeys.resistTypes.cock]: {
        sizeOpt: 3,
        sizeS: [
          `++++ rides xxxx's tiny cock, with #### hungry anal passage`,
          `++++ presses #### arsecheeks against xxxx's cute, hard shaft`,
          `++++ easily slides xxxx's tiny cock into #### slippery, hungry arse`,
        ],
        sizeM: [
          `++++ rides the top of xxxx's hard cock, with #### hungry anal passage`,
          `++++ presses #### arsecheeks against xxxx's hard shaft, rubbing #### cheeks along it`,
          `++++ easily slides xxxx's hard cock into #### slippery, hungry arse`,
        ],
        sizeL: [
          `++++ rides the tip xxxx's enormous cock, with #### snug anal passage`,
          `++++ presses #### arsecheeks against xxxx's long, hard shaft, rubbing ####self along it's sizable length`,
          `++++ slides ####self over xxxx's giant cock, taking the giant shaft entirely into #### arsehole`,
        ],
      },
      [CharKeys.resistTypes.touch]: {
        sizeOpt: false,
        sizeX: [`++++ rubs #### soft arsecheeks over xxxx's body`,],
      },
      [CharKeys.resistTypes.breasts]: {
        sizeOpt: false,
        sizeX: [`++++ rubs #### soft arsecheeks over xxxx's breasts`,],
      },
      [CharKeys.resistTypes.vagina]: {
        sizeOpt: false,
        sizeX: [`++++ rubs #### soft arsecheeks against xxxx's clit`,],
      },
      [CharKeys.resistTypes.anus]: {
        sizeOpt: false,
        sizeX: [`++++ rubs #### soft arsecheeks against xxxx's`,],
      },
    },
  },
};
